var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IriadeTextarea',_vm._g({attrs:{"label":_vm.input.label,"error-messages":_vm.errors,"hint":_vm.input.config.hint}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }